jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchstart", handle, { passive: false });
    } else {
      this.addEventListener("touchstart", handle, { passive: true });
    }
  }
};

jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchmove", handle, { passive: false });
    } else {
      this.addEventListener("touchmove", handle, { passive: true });
    }
  }
};

AOS.init()

/**** Main menu ****/
  
$(".navi li").each(function () {
  var li = $(this);
  if (li.find('ul li').length > 0) {
    li.append("<a href='javascript:;' rel='nofollow noopener' class='expand' onclick='return false;'><span class='icon-expand' aria-hidden='true'></span></a>");
    li.append("<a href='javascript:;' rel='nofollow noopener' class='collapse' onclick='return false;'><span class='icon-collapse' aria-hidden='true'></span></a>");
  }
});

$('body').on('click', 'a.expand', function () {
  $(this).hide().next().show();
  $(this).parent().siblings().find('ul').slideUp();
  $(this).parent().siblings().find('a.expand').show();
  $(this).parent().siblings().find('a.collapse').hide();
  $(this).parent().find('>ul').addClass('expanded').stop(true, true).slideDown();
});

$('body').on('click', 'a.collapse', function () {
  $(this).parent().find('ul').removeClass('expanded').stop(true, true).slideUp();
  $(this).parent().find('a.collapse').hide();
  $(this).parent().find('a.expand').show();
});

$(".hamburger").on('click', function () {
  $(".hamburger").toggleClass("is-active");
  $(".header-container").toggleClass("navi-open");
  $(".navigation-wrapper").toggleClass("navi-open");
  $("body").toggleClass("navi-open");
});

if ($('.gallery-slider').length > 0) {
  document.addEventListener('DOMContentLoaded', function () {
    var splide = new Splide('.gallery-slider', {
      rewind: true,
      arrows: true,
      pagination: true,
      perPage: 1,
      drag: true,
      speed: 1500,
      rewind: true,
      rewindSpeed: 1500
    }).mount();
  });
}

$(".subscribeform").on('submit', function () {
  $("#newsletter .list-loader-container").show();
  var form = $(this);
  $(".subscribeform-required").hide();
  var dosubmit = true;
  $(".subscribeform-input").each(function () {
    if ($(this).val() == '') {
      dosubmit = false;
      $(".subscribeform-required").show();
      $("#newsletter .list-loader-container").hide();
    }
  });

  if (dosubmit) {
    $.post($(this).attr('action'), form.serializeArray(), function (response) {
      var successTxt = 'You have successfully subscribed to our newsletter.';
      form.replaceWith(successTxt);
      $("#newsletter .list-loader-container").hide();
    });
  }
  return false;
});


// wrap divs with same class
$(".info-text-block").each(function() {
  if (!$(this).prev().hasClass("info-text-block")) {
      $(this).nextUntil(":not(.info-text-block)").addBack().wrapAll("<div class='info-text-block-wrapper'></div>");
  }
});

// wrap divs with same class
$(".blue-block").each(function() {
  if (!$(this).prev().hasClass("blue-block")) {
      $(this).nextUntil(":not(.blue-block)").addBack().wrapAll("<div class='blue-blocks-list'></div>");
  }
});

// wrap divs with same class
$(".blue-block-image").each(function() {
  if (!$(this).prev().hasClass("blue-block-image")) {
      $(this).nextUntil(":not(.blue-block-image)").addBack().wrapAll("<div class='blue-image-blocks-list'></div>");
  }
});